import React, { useContext } from "react";
import { Typography, Grid } from "@mui/material";
import { DataContext } from "../context/DataContext";

export default function FeaturePreview(props) {
  const dataContext = useContext(DataContext);
  const info = props.feature.properties;
  const translatedLandUse = dataContext.glossar?.[info.land]?.[info.bodennutzungstyp];
  const landUseText = translatedLandUse
    ? `${info.bodennutzungstyp} (${translatedLandUse})`
    : info.bodennutzungstyp || "Nicht bekannt";

  return (
    <>
      {props.feature?.properties && (
        <Grid container spacing={2} sx={{ width: "100%" }}>
          <Grid size={6} sx={{ minWidth: 0 }}>
            <Typography variant="h6"> FLIK-Nummer </Typography>
            <Typography variant="body1">
              {info.feldblockidentnummer}
            </Typography>
          </Grid>
          <Grid size={6} sx={{ minWidth: 0 }}>
            <Typography variant="h6"> Bodennutzungsart </Typography>
            <Typography
              variant="body1"
              sx={{ overflowWrap: "anywhere", wordBreak: "break-word" }}
            >
              {landUseText}
            </Typography>
          </Grid>
        </Grid>
      )}
    </>
  );
}
